const actions = {
  SET_STATE: 'peyme/SET_STATE',
  FETCH_ALL_PEYME: 'peyme/FETCH_ALL_PEYME',
  VERIFIED_UNVERIFIED_BUSINESS: 'peyme/VERIFIED_UNVERIFIED_BUSINESS',
}

export default actions
